import { useGA4React } from 'ga-4-react';
import { Settings } from '../../app/settings';

const googleAnalyticsCode = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE;

export const useAnalytics = () => {
  useGA4React(googleAnalyticsCode, { debug_mode: Settings.enableDebug });
};
